import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import KetoContainer from './keto-container';
import styles from './keto-banner.module.css';

export default function KetoBanner() {
  return (
    <section className={styles.banner}>
      <AnimationOnScroll
        offset={400}
        animateOnce
        duration={1.2}
        animateIn="animate__fadeInUp"
        className={styles.about_inner}
      >
        <KetoContainer>
          <Image width={1300} height={760} src="/keto/banner/banner.png" />
        </KetoContainer>
      </AnimationOnScroll>
    </section>
  );
}
